const ITEMS = [
  "The Zo Pound Experience",
  "Highlighting Haitian Greatness",
  "Simplicity Films LLC",
  "Respect",
  "Truth",
  "Culture",
  "Haiti",
  "Miami",
];

function Strip() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-bold uppercase tracking-wider text-2xl sm:text-3xl text-gray-200 px-6 whitespace-nowrap">
            {item}
          </span>
          <span className={`w-2 h-2 rotate-45 ${i % 2 === 0 ? "bg-blood" : "bg-royal"}`} />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-t-2 border-blood border-b-2 border-b-royal bg-surface py-5 overflow-hidden"
    >
      <div className="flex w-max animate-marquee">
        <Strip />
        <Strip />
      </div>
    </div>
  );
}
